import {Component, OnDestroy, OnInit} from '@angular/core';
import {StorageItem} from '../../../enums/storage-item';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ApplicationService} from '../../../services/application.service';
import {ConfigurationService} from '../../../services/configuration.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {ExternalService} from '../../../services/external.service';
import {Application} from '../../../domain/onBoarding/application';
import {Profile} from '../../../domain/authentication/profile';
import {ApplicationBody} from '../../../domain/onBoarding/application-body';
interface IValidation {
  id: number;
  name: string;
  agentParams: {agentMode: null };
}
@Component({
  selector: 'app-start-screen',
  templateUrl: './start-screen.component.html',
  styleUrls: ['./start-screen.component.scss']
})
export class StartScreenComponent extends CommonComponent implements OnInit, OnDestroy {
  application: Application;
  locale = this.route.snapshot.queryParamMap.get('locale');
  private profile: Profile;
  externalReferenceCode  = this.route.snapshot.queryParamMap.get('externalReferenceCode');
  altairParentAgentCode  = this.route.snapshot.queryParamMap.get('code');
  notLocationAllowed = true;
  showMessageLocation = true;
  displaySpinner = true;
  constructor(
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private applicationService: ApplicationService,
    public configurationService: ConfigurationService,
    private localStorageService: LocalStorageService,
    private route: ActivatedRoute,
    private externalService: ExternalService,
    private localStorage: LocalStorageService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
    translate.addLangs(['es', 'en']);

    if (this.locale === 'es' || this.locale === 'en'){
      translate.use(this.getValidLanguage(this.locale));
      let profile: any = this.localStorage.get(StorageItem.PROFILE);
      profile = {
        locale: this.locale
      };
      this.localStorage.set(StorageItem.PROFILE, profile);
    }
  }

  ngOnInit(): void {
    this.onBoardingInit();
  }


  onBoardingInit() {
    this.loadingModalOn();
    this.configurationService.getPlatformConfigService().subscribe(
      response => {
        this.profile = this.localStorageService.get(StorageItem.PROFILE);
        this.getIpAddress();
        if (this.externalReferenceCode &&
          this.externalReferenceCode.length <= this.configurationService.application.externalReferenceCodeMaxLength){
          this.applicationService.application.body.externalReferenceCode = this.externalReferenceCode;
        }
        this.getSystemInfo();
      }, error => {
        this.profile = this.localStorageService.get(StorageItem.PROFILE);
        this.getIpAddress();
        if (this.externalReferenceCode &&
          this.externalReferenceCode.length <= 50){
          this.applicationService.application.body.externalReferenceCode = this.externalReferenceCode;
        }
        this.getSystemInfo();
      }
    );
  }

  getIpAddress() {
    this.externalService.getIPAddress().subscribe((res: any) => {
      this.application.body.ipAddress = res.ip;
    }, () => {
      this.loadingModalOff();
    }
    );
  }

  getSystemInfo() {
    this.application.body.locale = this.profile ? this.profile.locale : window.location.pathname.substring(1, 3);
    if (this.application.body.locale.substring(0, 2) !== 'en' && this.application?.body.locale.substring(0, 2) !== 'es') {
      if (navigator.language.toLowerCase().substring(0, 2) === 'en' || navigator.language.toLowerCase().substring(0, 2) === 'es'){
        this.application.body.locale = navigator.language.toLowerCase().substring(0, 2);
      }else {
        this.application.body.locale = 'en';
      }
    }
    this.application.body.locale = this.application?.body?.locale.substring(0, 2);
    this.translate.use(this.application?.body?.locale);
    if (this.configurationService.account.enableGeolocation === true) {
      this.getCurrentPosition().then(pos => {
          this.application.body.latitude = pos.lat;
          this.application.body.longitude = pos.lng;
          this.notLocationAllowed = false;
          this.checkPermission();
        },
        error => {
          this.notLocationAllowed = true;
          this.showMessageLocation = false;
          this.loadingModalOff();
        });
    } else {
      this.notLocationAllowed = false;
      this.showMessageLocation = false;
    }
  }
  checkPermission(){
    navigator.mediaDevices.getUserMedia({video: {}}).then((response) => {
        if (this.route.snapshot.params.token){
          this.application.recoveryToken = this.route.snapshot.params.token;
          this.recoveryData();
        }else{
          if (this.altairParentAgentCode){
            this.verifyUrlAgentCode();
            return;
          }else {
            this.nextPage();
          }
        }
        this.loadingModalOff();
      }
    ).catch(error => {
      this.loadingModalOff();
      this.msgError(error, this.translate.instant('onboarding.contact-data.cameraUsageDenied', {Default: 'Es necesario que permita el uso de su cámara web. Por favor, brinde autorización y recargue la página.'}));
      this.application = null;
      this.router.navigate(['/']);
    }).finally(() =>
      this.loadingModalOff()
    );
  }

  recoveryData() {
    this.applicationService.recoverApplication(this.application.recoveryToken).subscribe(
      (response: ApplicationBody) => {
        this.application.body = response;
        this.application.confirmedPhoneNumber = true;
        this.application.confirmedEmail = true;
        this.application.body.applicationId = response.applicationId;
        this.application.body.rejectedAppToken = this.application.recoveryToken;
        this.translate.use(this.application.body.locale.substring(0, 2));
        this.application.editing = true;
        this.loadingModalOff();
        this.router.navigate(['/onboarding/usaIds']);
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  verifyUrlAgentCode() {
    this.loadingModalOn();
    this.application.altairParentAgentCode = this.altairParentAgentCode;
    this.applicationService.getCodeValidation(this.application.altairParentAgentCode).subscribe(
      (response: IValidation) => {
        this.application.body.altairParentAgentId = response?.id;
        this.application.body.agentMode = response?.agentParams?.agentMode || null;
        this.application.editing = true;
        this.nextPage();
        this.loadingModalOff();
      },
      error => {
        this.application.invalidReferredCode = true;
        this.nextPage();
        this.loadingModalOff();
      }
    );

  }


  nextPage(){
    this.application.editing = true;
    if (this.configurationService.application.brokerEnabled === false || this.application.body.altairParentAgentId ||
      this.configurationService.application.sendBrokerScreenToEnd) {
      this.router.navigate(['/onboarding/contactData']);
    }else {
      this.router.navigate(['/onboarding/addReferrer']);
    }
  }
  ngOnDestroy() {
    if (!this.configurationService.application.onboardingEnable){
      this.router.navigate(['']);
    }
    this.loadingModalOff();
  }

}
